import type { PlatformStockImportResult } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const exportPlatformStocks = async (params?: {
  storeReference?: string
  internalCategoryIds?: number[]
}): Promise<Blob> => {
  const response = await gozokiApiWithAuth.get('/platform-stocks/export', {
    params,
    responseType: 'blob',
  })
  return response.data
}

export const importPlatformStocks = async (file: File): Promise<PlatformStockImportResult> => {
  const formData = new FormData()
  formData.append('importFile', file)
  const response = await gozokiApiWithAuth.post<PlatformStockImportResult>(
    '/platform-stocks/import',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return response.data
}
